var _path, _path2, _path3, _path4, _path5, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideBurgerMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 7.12C1.4 6.72236 1.72236 6.4 2.12 6.4H20.88C21.2776 6.4 21.6 6.72235 21.6 7.12V19.88C21.6 20.2776 21.2776 20.6 20.88 20.6H2.12C1.72235 20.6 1.4 20.2776 1.4 19.88V7.12Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 4C15.8997 4 16 4.10029 16 4.224L16 4.8L7 4.8L7 4.224C7 4.10029 7.10029 4 7.224 4L15.776 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5L16 6.5L15 6.5L15 4.5L16 4.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5L8 6.5L7 6.5L7 4.5L8 4.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0694 13.5051C15.0694 15.5145 13.4358 17.1453 11.4183 17.1453C9.40083 17.1453 7.76719 15.5145 7.76719 13.5051C7.76719 11.4956 9.40083 9.86484 11.4183 9.86484C13.4358 9.86484 15.0694 11.4956 15.0694 13.5051Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9844,
    y: 11.7812,
    width: 0.868097,
    height: 3.46306,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1562,
    y: 13.0781,
    width: 0.865764,
    height: 3.47239,
    transform: "rotate(90 13.1562 13.0781)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBurgerMedical);
export default __webpack_public_path__ + "static/media/SideBurgerMedical.156efacf551ab135c012c09b54b11bea.svg";
export { ForwardRef as ReactComponent };